export default __webpack_public_path__ + "static/webinar-thumbnail-158c2b11a10d28596f697244ccd85cc9.png";